import React, { useState, useEffect } from 'react';
import { masterAdminAPI } from '../../services/api';
import toast from 'react-hot-toast';
import AddCreditsModal from '../../components/master/AddCreditsModal';

const SchoolsList = () => {
  const [schools, setSchools] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedSchool, setSelectedSchool] = useState(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    fetchSchools();
  }, []);

  const fetchSchools = async () => {
    try {
      const res = await masterAdminAPI.getAllSchools();
      // Optionally fetch wallet balances for each school (maybe backend should include)
      setSchools(res.data);
    } catch (error) {
      toast.error('Failed to load schools');
    } finally {
      setLoading(false);
    }
  };

  const handleAddCredits = (school) => {
    setSelectedSchool(school);
    setShowModal(true);
  };

  const handleSuspend = async (id) => {
    if (!window.confirm('Suspend this school?')) return;
    try {
      await masterAdminAPI.suspendSchool(id);
      toast.success('School suspended');
      fetchSchools();
    } catch (error) {
      toast.error('Failed');
    }
  };

  const handleUnsuspend = async (id) => {
    try {
      await masterAdminAPI.unsuspendSchool(id);
      toast.success('School unsuspended');
      fetchSchools();
    } catch (error) {
      toast.error('Failed');
    }
  };

  const getStatusBadge = (school) => {
    if (school.is_suspended) return <span className="bg-red-100 text-red-800 px-2 py-1 rounded">Suspended</span>;
    if (school.is_active) return <span className="bg-green-100 text-green-800 px-2 py-1 rounded">Active</span>;
    if (school.approval_status === 'pending') return <span className="bg-yellow-100 text-yellow-800 px-2 py-1 rounded">Pending</span>;
    if (school.approval_status === 'rejected') return <span className="bg-gray-100 text-gray-800 px-2 py-1 rounded">Rejected</span>;
    return <span className="bg-gray-100 text-gray-800 px-2 py-1 rounded">Inactive</span>;
  };

  if (loading) return <div>Loading...</div>;

  return (
    <div>
      <h1 className="text-2xl font-bold mb-6">All Schools</h1>
      <table className="min-w-full bg-white rounded-lg shadow">
        <thead>
          <tr className="bg-gray-100">
            <th className="px-4 py-2 text-left">Name</th>
            <th className="px-4 py-2 text-left">Reg Code</th>
            <th className="px-4 py-2 text-left">Status</th>
            <th className="px-4 py-2 text-left">Wallet</th>
            <th className="px-4 py-2 text-left">Actions</th>
          </tr>
        </thead>
        <tbody>
          {schools.map((school) => (
            <tr key={school.id} className="border-t">
              <td className="px-4 py-2">{school.name}</td>
              <td className="px-4 py-2">{school.reg_code}</td>
              <td className="px-4 py-2">{getStatusBadge(school)}</td>
              <td className="px-4 py-2">{school.wallet?.credit_balance || 0} credits</td>
              <td className="px-4 py-2 space-x-2">
                <button
                  onClick={() => handleAddCredits(school)}
                  className="bg-blue-500 text-white px-3 py-1 rounded hover:bg-blue-600"
                >
                  Add Credits
                </button>
                {school.is_suspended ? (
                  <button
                    onClick={() => handleUnsuspend(school.id)}
                    className="bg-green-500 text-white px-3 py-1 rounded hover:bg-green-600"
                  >
                    Unsuspend
                  </button>
                ) : (
                  <button
                    onClick={() => handleSuspend(school.id)}
                    className="bg-yellow-500 text-white px-3 py-1 rounded hover:bg-yellow-600"
                  >
                    Suspend
                  </button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {showModal && (
        <AddCreditsModal
          school={selectedSchool}
          onClose={() => setShowModal(false)}
          onSuccess={() => {
            setShowModal(false);
            fetchSchools();
          }}
        />
      )}
    </div>
  );
};

export default SchoolsList;